export default __webpack_public_path__ + "static/media/logo-white.77acae44.svg";